const isValidHex = hex => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);

const isValidRgb = rgb => /(^rgb[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*(?:,(?![)])|(?=[)]))){3}[)]$)/i.test(rgb);

const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
    : null;
}

const parseRgb = rgb => {
  const result = rgb.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
  return result
    ? {
      r: parseInt(result[1], 10),
      g: parseInt(result[2], 10),
      b: parseInt(result[3], 10)
    }
    : null;
}

export const getOpacityColor = (color, opacity) => {
  let result;
  if (isValidHex(color)) {
    result = hexToRgb(color);
  }
  if (isValidRgb(color)) {
    result = parseRgb(color);
  }
  return result ? 'rgb(' + result.r + ',' + result.g + ',' + result.b + ',' + opacity + ')' : null;
}
